import React from 'react'
import { useTranslation } from 'react-i18next'

import styles from './ActivityCheckSubmitCard.module.scss'
import { PercentButton } from '@percent/admin-dashboard/common/components'
import { Button, Card, Divider } from '@percent/lemonade'
import { WebsiteCopyLink } from '@percent/admin-dashboard/common/components/websiteCopyLink/WebsiteCopyLink'
import { ActivityCheckSubmitCardProps } from './ActivityCheckDetail.types'

export function ActivityCheckSubmitCard({ setIsOpened, orgWebsite, orgName, orgId }: ActivityCheckSubmitCardProps) {
  const { t } = useTranslation()

  return (
    <Card className={styles.wrapper}>
      <Divider className={styles.divider} />
      <div className={styles.contentWrapper}>
        <div className={styles.organisationInfoWrapper}>
          <span className={styles.text}>{orgName}</span>
          <WebsiteCopyLink orgWebsite={orgWebsite} />
        </div>
        <div className={styles.buttonWrapper}>
          {orgId && (
            <Button
              size="small"
              variant="secondary"
              onClick={() => {
                window.open(`/organizations/${orgId}`, '_blank')
              }}
            >
              {t('typography.viewOrganizationDetails')}
            </Button>
          )}
          <PercentButton title={t('button.submitCode')} onClick={() => setIsOpened(true)} />
        </div>
      </div>
    </Card>
  )
}
